import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";
import { fieldOptionRetrieve } from "utils/common";

import Stack from "components/Stack";
import Text from "components/Text";

import PrintableMemoFieldTitle from "pages/Deal/PrintableMemo/components/PrintableMemoFieldTitle";

import { IPackageDetailsField } from "entities/Checklist/sdk";

interface IPrintableMemoDropdownField {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableMemoDropdownField = ({
  field,
  isNASection,
}: IPrintableMemoDropdownField) => {
  const value = useMemo(
    () =>
      fieldOptionRetrieve({
        options: field.options,
        value: _.get(field.values, "[0].selected_value"),
      }),
    [field.options, field.values]
  );

  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  const showFieldValue = useMemo(() => !isNAField && value, [isNAField, value]);

  return (
    <Stack direction="row" sx={{ borderBottom: `1px solid ${colors.blue40}` }}>
      <PrintableMemoFieldTitle field={field} disabled={isNAField} />

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="flex-end"
        sx={{ flex: 1 }}
      >
        {showFieldValue && (
          <Text variant="text2" data-testid="field-value">
            {value?.label}
          </Text>
        )}
        {isNAField && (
          <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
            N/A
          </Text>
        )}
      </Stack>
    </Stack>
  );
};

export default PrintableMemoDropdownField;
